import { ProDetailList, ProText } from '@bedrock/eed-react';
import {
  FormCard,
  FormDescriptions,
  FormItemBaseEnum,
  FormItemBaseFile,
  FormModule,
  SupplierDetailList,
} from '@purchase/supplier';
import React, { useMemo } from 'react';
import { get } from 'lodash-es';
import { ProCustomFieldDateRange } from '../../components/ProCustomFieldDateRange';
import { ProLink } from '../../components/ProLink';
import { ProTextEllipsis } from '../../components/ProTextEllipsis';

export const ResourceCapabilities = (props: {
  namePath?: string[];
  mode?: 'card' | 'module';
  formItemProps?: any;
  formDetail?: any;
}) => {
  const { namePath = [], mode = 'module', formItemProps, formDetail } = props;
  const Wrapper = mode === 'card' ? FormCard : FormModule;
  const resourceCount = useMemo(() => {
    const exclusiveCount =
      get(formDetail, [
        ...namePath,
        'extendAttributeInfo',
        'serviceInformation',
        'exclusiveResourceDetails',
      ])?.length ?? 0;
    const advantageCount =
      get(formDetail, [
        ...namePath,
        'extendAttributeInfo',
        'resourceCapability',
      ])?.length ?? 0;
    return exclusiveCount + advantageCount;
  }, [formDetail, namePath]);

  return (
    <Wrapper
      title="资源能力"
      titleCount={resourceCount}
      proCardProps={{ expandable: true, defaultExpanded: resourceCount > 0 }}
    >
      <FormDescriptions columns={2} labelStyle={{ width: 180 }} margin={false}>
        {/* 独家资源子表格 */}
        <SupplierDetailList
          name={[
            ...namePath,
            'extendAttributeInfo',
            'serviceInformation',
            'exclusiveResourceDetails',
          ]}
          span={2}
          label="独家资源"
          fieldProps={{ scroll: { x: 920 } }}
          formItemProps={formItemProps}
        >
          <ProDetailList.Item
            label="#"
            name="#"
            meta={{ columnProps: { width: 50, fixed: true } }}
          >
            {(_, record) => ({
              children: record?.$index + 1,
              props: { rowSpan: record?.$rowSpan },
            })}
          </ProDetailList.Item>
          <ProDetailList.Item
            label="平台"
            name="platform"
            meta={{
              columnProps: {
                width: 160,
                className: 'font-bold',
                fixed: true,
              },
            }}
          >
            {(_, record) => ({
              children: <FormItemBaseEnum />,
              props: { rowSpan: record?.$rowSpan },
            })}
          </ProDetailList.Item>
          <ProDetailList.Item
            label="独家资源说明"
            name="exclusiveResourceDes"
            meta={{ columnProps: { width: 300 } }}
          >
            {(_, record) => ({
              children: <ProTextEllipsis />,
              props: { rowSpan: record?.$rowSpan },
            })}
          </ProDetailList.Item>
          <ProDetailList.Item
            label="MCN机构名称"
            name="mcnName"
            meta={{ columnProps: { width: 200 } }}
          >
            {(_, record) => ({
              children: <ProText />,
              props: { rowSpan: record?.$rowSpan },
            })}
          </ProDetailList.Item>
          <ProDetailList.Item
            label="证明附件"
            name="proofAttachment"
            meta={{ columnProps: { width: 240 } }}
          >
            {(_, record) => ({
              children: <FormItemBaseFile />,
              props: { rowSpan: record?.$rowSpan },
            })}
          </ProDetailList.Item>
          <ProDetailList.Item
            label="达人名称"
            name="nickname"
            meta={{ columnProps: { width: 180 } }}
          >
            <ProTextEllipsis />
          </ProDetailList.Item>
          <ProDetailList.Item
            label="主页链接"
            name="homePageUrl"
            meta={{ columnProps: { width: 180 } }}
          >
            <ProLink ellipsis />
          </ProDetailList.Item>
          <ProDetailList.Item
            label="独家授权证明"
            name="exclusiveAuthorizationProof"
            meta={{ columnProps: { width: 240 } }}
          >
            <FormItemBaseFile />
          </ProDetailList.Item>
          <ProDetailList.Item
            label="独家授权期限"
            name="exclusiveAuthorizationPeriod"
            meta={{ columnProps: { width: 300 } }}
          >
            <ProCustomFieldDateRange />
          </ProDetailList.Item>
        </SupplierDetailList>

        {/* 优势资源子表格 */}
        <SupplierDetailList
          name={[...namePath, 'extendAttributeInfo', 'resourceCapability']}
          span={2}
          label="优势资源"
          fieldProps={{ scroll: { x: 920 } }}
          formItemProps={formItemProps}
        >
          <ProDetailList.Item
            label="#"
            name="#"
            meta={{ columnProps: { width: 50, fixed: true } }}
          >
            {(value, record, index) => index + 1}
          </ProDetailList.Item>
          <ProDetailList.Item
            label="资源性质"
            name="resourceType"
            meta={{
              columnProps: { width: 160, className: 'font-bold', fixed: true },
            }}
          >
            <FormItemBaseEnum />
          </ProDetailList.Item>
          <ProDetailList.Item label="资源描述" name="specificResourceDesc">
            <ProTextEllipsis />
          </ProDetailList.Item>
          <ProDetailList.Item
            label="优势资源平台"
            name="advantageousPlatform"
            meta={{ columnProps: { width: 130 } }}
          >
            <FormItemBaseEnum />
          </ProDetailList.Item>
          <ProDetailList.Item
            label="附件类型"
            name="resourceAttachmentType"
            meta={{ columnProps: { width: 120 } }}
          >
            <FormItemBaseEnum />
          </ProDetailList.Item>
          <ProDetailList.Item
            label="附件"
            name="resourceAttachment"
            meta={{ columnProps: { width: 240 } }}
          >
            <FormItemBaseFile />
          </ProDetailList.Item>
        </SupplierDetailList>
      </FormDescriptions>
    </Wrapper>
  );
};
